import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { palette, spacing, typography } from 'main/ui'

export const Container = styled.div`
  align-items: center;
  display: inline-flex;
  font-size: ${typography.fontSize.text};
`

export const Stars = styled.div`
  position: relative;

  &::before {
    color: ${palette.goldenrod};
    content: '\\2606\\2606\\2606\\2606\\2606';
  }
`

export const FilledStars = styled.div<{ fillPercentage: number }>`
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: ${({ fillPercentage }) => `${fillPercentage * 100}%`};

  &::after {
    color: ${palette.goldenrod};
    content: '\\2605\\2605\\2605\\2605\\2605';
  }
`

export const labelStyles = css`
  font-size: ${typography.fontSize.small};
  margin-left: ${spacing.minorScale(1)}px;
`
